// extracted by mini-css-extract-plugin
export var section = "card-module--section--DCAzp";
export var container = "card-module--container--5kWGC";
export var img = "card-module--img--Xm4RK";
export var list = "card-module--list--7E190";
export var item = "card-module--item--I-ukU";
export var title = "card-module--title--Ffo3D";
export var text = "card-module--text--QDJSQ";